import { CRUDActionsEnum } from './../../../enum/crud-actions.enum';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'announcement-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  constructor() { }

  @Input() announcement: any = {};
  @Input() canEdit: boolean;
  @Output() onActionClick = new EventEmitter();
  public crudActions = CRUDActionsEnum;

  ngOnInit() {
  }

  public actionClick(action: string): void {
    if (action == this.crudActions.DELETE) {
      if (confirm('Are you sure you want to Delete announcement?')) {
        this.onActionClick.emit({ action: action, _id: this.announcement._id });
      }
    } else {
      this.onActionClick.emit({ action: action, _id: this.announcement._id });
    }
  }
}
